'use strict';

var useMediaQuery = require('../../node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js');



module.exports = useMediaQuery;
